import { render, staticRenderFns } from "./userDetailForm.vue?vue&type=template&id=90fd235e&scoped=true&"
import script from "./userDetailForm.vue?vue&type=script&lang=ts&"
export * from "./userDetailForm.vue?vue&type=script&lang=ts&"
import style0 from "./userDetailForm.vue?vue&type=style&index=0&id=90fd235e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fd235e",
  null
  
)

export default component.exports